(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const duration = 8 * 60;
    const storageKey = 'rive-cart-reservation-end';

    const getEndTime = () => {
      const stored = Number(sessionStorage.getItem(storageKey) || 0);
      if (stored > Date.now()) return stored;
      const next = Date.now() + duration * 1000;
      sessionStorage.setItem(storageKey, String(next));
      return next;
    };

    const updateCountdown = () => {
      const elements = document.querySelectorAll('[data-rive-cart-countdown]');
      if (!elements.length) return;
      const remaining = Math.max(0, Math.ceil((getEndTime() - Date.now()) / 1000));
      const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
      const seconds = String(remaining % 60).padStart(2, '0');
      elements.forEach((element) => { element.textContent = `${minutes}:${seconds}`; });
      if (remaining === 0) sessionStorage.removeItem(storageKey);
    };

    updateCountdown();
    setInterval(updateCountdown, 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    function initializeBuyNowCheckoutButtons() {
    document.querySelectorAll('[data-buy-now-checkout]').forEach(function(button) {
      var form = button.closest('form[action*="/cart/add"]');
      var addToCartButton = form && form.querySelector('[data-add-to-cart]');

      if (!form || !addToCartButton) return;

      var syncAvailability = function() {
        button.disabled = addToCartButton.disabled;
      };

      syncAvailability();
      new MutationObserver(syncAvailability).observe(addToCartButton, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    });
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-buy-now-checkout]');
    if (!button || button.disabled) return;

    var form = button.closest('form[action*="/cart/add"]');
    var variantInput = form && form.querySelector('[name="id"]');
    var quantityInput = form && form.querySelector('[name="quantity"]');

    if (!variantInput || !variantInput.value) return;

    var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value || '1', 10) || 1);
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    root = root.endsWith('/') ? root : root + '/';
    window.location.assign(root + 'cart/' + encodeURIComponent(variantInput.value) + ':' + quantity);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBuyNowCheckoutButtons);
  } else {
    initializeBuyNowCheckoutButtons();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sevilla-quantity-offer"] && !Shopify.designMode) return;
  try {
    function initializeSevillaOffers(scope) {
    scope.querySelectorAll('[data-sevilla-offer]').forEach(function(offer) {
      if (offer.dataset.initialized === 'true') return;
      offer.dataset.initialized = 'true';

      var form = document.getElementById(offer.dataset.formId);
      if (!form) return;

      var quantityInput = form.querySelector('[name="quantity"]');
      if (!quantityInput) {
        quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.name = 'quantity';
        form.appendChild(quantityInput);
      }

      var selectedOption = offer.querySelector('[data-quantity][aria-pressed="true"]') || offer.querySelector('[data-quantity]');
      var selectedQuantity = Number(selectedOption && selectedOption.dataset.quantity) || 1;
      var selectedDiscount = Number(selectedOption && selectedOption.dataset.discount) || 0;
      var selectedCode = selectedOption && selectedOption.dataset.discountCode || '';

      function money(value) {
        return new Intl.NumberFormat(offer.dataset.locale || document.documentElement.lang || 'es', {
          style: 'currency',
          currency: offer.dataset.currency || 'EUR'
        }).format(value / 100);
      }

      function currentPrice() {
        var select = form.querySelector('[data-product-select]');
        var variantsElement = form.querySelector('[data-variant-json]');
        if (!select || !variantsElement) return Number(offer.dataset.price) || 0;

        try {
          var variants = JSON.parse(variantsElement.value || variantsElement.textContent);
          var selected = variants.find(function(variant) {
            return String(variant.id) === String(select.value);
          });
          return selected ? Number(selected.price) : Number(offer.dataset.price) || 0;
        } catch (error) {
          return Number(offer.dataset.price) || 0;
        }
      }

      function updateOffer() {
        var unitPrice = currentPrice();

        offer.querySelectorAll('[data-quantity]').forEach(function(option) {
          var quantity = Number(option.dataset.quantity);
          var discount = Number(option.dataset.discount);
          var discountPerUnit = Math.floor(unitPrice * discount / 100);
          var optionUnit = unitPrice - discountPerUnit;
          var optionTotal = optionUnit * quantity;
          var price = option.querySelector('[data-option-price]');
          price.innerHTML = money(optionTotal) + '<small>' + money(optionUnit) + ' ' + offer.dataset.unit + '</small>';
        });

        var subtotal = unitPrice * selectedQuantity;
        var discountValue = Math.floor(unitPrice * selectedDiscount / 100) * selectedQuantity;
        var total = subtotal - discountValue;
        quantityInput.value = selectedQuantity;
        offer.querySelector('[data-offer-subtotal]').textContent = money(subtotal);
        offer.querySelector('[data-offer-discount]').textContent = selectedDiscount ? '−' + money(discountValue) : money(0);
        offer.querySelector('[data-offer-total]').textContent = money(total);

        var addText = form.querySelector('[data-add-to-cart-text]');
        if (addText) {
          var label = selectedQuantity === 1 ? offer.dataset.addOne : offer.dataset.addMany.replace('__quantity__', selectedQuantity);
          addText.textContent = label + ' · ' + money(total);
        }
      }

      offer.addEventListener('click', function(event) {
        var option = event.target.closest('[data-quantity]');
        if (!option) return;

        var applySelection = function() {
          offer.querySelectorAll('[data-quantity]').forEach(function(item) {
            var active = item === option;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          selectedQuantity = Number(option.dataset.quantity);
          selectedDiscount = Number(option.dataset.discount);
          selectedCode = option.dataset.discountCode;
          updateOffer();
        };

        if (document.startViewTransition) {
          document.startViewTransition(applySelection);
        } else {
          applySelection();
        }
      });

      form.addEventListener('change', function() {
        window.setTimeout(updateOffer, 0);
      });

      form.addEventListener('submit', function(event) {
        if (!selectedCode || selectedQuantity === 1) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var addButton = form.querySelector('[data-add-to-cart]');
        if (addButton) {
          addButton.disabled = true;
          addButton.setAttribute('aria-busy', 'true');
        }

        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        root = root.endsWith('/') ? root : root + '/';

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new FormData(form)
        }).then(function(response) {
          if (!response.ok) throw new Error('cart');
          return response.json();
        }).then(function() {
          var redirect = root + 'cart';
          window.location.assign(root + 'discount/' + encodeURIComponent(selectedCode) + '?redirect=' + encodeURIComponent(redirect));
        }).catch(function() {
          if (addButton) {
            addButton.disabled = false;
            addButton.removeAttribute('aria-busy');
          }
          window.alert(offer.dataset.error);
        });
      }, true);

      updateOffer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeSevillaOffers(document);
    });
  } else {
    initializeSevillaOffers(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initializeSevillaOffers(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
